import APIClient from '@/shared/http/clients/api'

const resourceName = 'regulationautolog'
const APIRegAuto = process.env.APIBaseURLRegulationAuto

const GetAll = (data = {}, config = {}) => APIClient.get(`${APIRegAuto}/${resourceName}`, data, config)
const GetAllPaging = (limit, index, config = {}) => APIClient.get(`${APIRegAuto}/${resourceName}?limit=${limit}&index=${index}`, config)
const GetById = (regulationAutoID, limit, index, config = {}) => APIClient.get(`${APIRegAuto}/${resourceName}/regulationAutoID/${regulationAutoID}?limit=${limit}&index=${index}`, config)
const History = (limit, index, data = {}, config = {}) => APIClient.post(`${APIRegAuto}/${resourceName}/history?limit=${limit}&index=${index}`, data, config)

const RegulationAutoLogRepository = {
  GetAll,
  GetAllPaging,
  GetById,
  History
}

export default RegulationAutoLogRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/regulation/auto/regulationautolog.js